"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewFeatureIndicatorName = exports.stepsRequiringOnboardingCompletedFirst = exports.anytimeSteps = exports.contentLibrarySteps = exports.commentSteps = exports.onboardingSteps = exports.PagesOnboardingBannerAction = exports.ROIStepId = exports.TelemetryStepId = void 0;
var PromptTypes_1 = require("Prompt/PromptTypes");
var TelemetryStepId;
(function (TelemetryStepId) {
    TelemetryStepId["Comments"] = "comments tooltip";
    TelemetryStepId["ContentLibrary"] = "content library tooltip";
    TelemetryStepId["EditText"] = "editor highlight text 001";
    TelemetryStepId["Styles"] = "editor block styles 001";
    TelemetryStepId["AddBlock"] = "editor add block 001";
    TelemetryStepId["Share"] = "editor share 001";
})(TelemetryStepId = exports.TelemetryStepId || (exports.TelemetryStepId = {}));
var ROIStepId;
(function (ROIStepId) {
    ROIStepId["StartTour"] = "startTour";
    ROIStepId["Formula"] = "formula";
    ROIStepId["FormulaEditor"] = "editFormula";
    ROIStepId["ShowVariables"] = "showVariables";
    ROIStepId["AddEditVariables"] = "addEditVariables";
    ROIStepId["EditSlider"] = "editSlider";
})(ROIStepId = exports.ROIStepId || (exports.ROIStepId = {}));
var PagesOnboardingBannerAction;
(function (PagesOnboardingBannerAction) {
    PagesOnboardingBannerAction["EditorExperience"] = "pages_editorExperience";
    PagesOnboardingBannerAction["BrandSetup"] = "pages_brandSetup";
    PagesOnboardingBannerAction["GetHelp"] = "pages_getHelp";
    PagesOnboardingBannerAction["DocConversion"] = "pages_docConversion";
    PagesOnboardingBannerAction["CreateFromTemplate"] = "pages_createFromTemplate";
})(PagesOnboardingBannerAction = exports.PagesOnboardingBannerAction || (exports.PagesOnboardingBannerAction = {}));
exports.onboardingSteps = [PromptTypes_1.PromptId.EditText, PromptTypes_1.PromptId.Styles, PromptTypes_1.PromptId.AddBlock, PromptTypes_1.PromptId.Share];
exports.commentSteps = [PromptTypes_1.PromptId.Comments];
exports.contentLibrarySteps = [PromptTypes_1.PromptId.ContentLibrary];
exports.anytimeSteps = __spreadArray([], __read(exports.commentSteps), false);
exports.stepsRequiringOnboardingCompletedFirst = [PromptTypes_1.PromptId.ContentLibrary];
var NewFeatureIndicatorName;
(function (NewFeatureIndicatorName) {
    NewFeatureIndicatorName["AutomationsLibrary"] = "automationsLibrary";
})(NewFeatureIndicatorName = exports.NewFeatureIndicatorName || (exports.NewFeatureIndicatorName = {}));
